import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export const getSessionInfo = async (accessToken: string) => {
  return await fetch(`${API_BASE}/api/sessions`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
